/* =========================================================
   LiBu collection sidebar controls
   - POJ-like view switcher
   - Re-applies view after Shopify facet refresh
   ========================================================= */
(function () {
  const STORAGE_KEY = 'libuCollectionView';
  const ALLOWED = ['large', 'compact', 'list'];

  function getSwitcher() {
    return document.querySelector('.libu-sidebar-view-switch');
  }

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function getDefaultView() {
    const switcher = getSwitcher();
    const fromSection = switcher && switcher.getAttribute('data-default-view');
    return ALLOWED.includes(fromSection) ? fromSection : 'compact';
  }

  function getSavedView() {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      return ALLOWED.includes(saved) ? saved : null;
    } catch (error) {
      return null;
    }
  }

  function saveView(view) {
    try {
      window.localStorage.setItem(STORAGE_KEY, view);
    } catch (error) {
      // Ignore storage errors.
    }
  }

  function applyView(view, persist) {
    if (!ALLOWED.includes(view)) view = getDefaultView();

    const grid = getGrid();
    if (grid) {
      grid.classList.remove('libu-view-large', 'libu-view-compact', 'libu-view-list');
      grid.classList.add('libu-view-' + view);
      grid.setAttribute('data-libu-view', view);
    }

    document.querySelectorAll('.libu-view-button').forEach((button) => {
      const active = button.getAttribute('data-libu-view') === view;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (persist) saveView(view);
  }

  function initSwitcher() {
    const switcher = getSwitcher();
    if (!switcher) return;

    const view = getSavedView() || getDefaultView();
    applyView(view, false);

    switcher.querySelectorAll('.libu-view-button').forEach((button) => {
      button.addEventListener('click', () => {
        applyView(button.getAttribute('data-libu-view'), true);
      });
    });
  }

  function observeProductGridRefresh() {
    const container = document.getElementById('ProductGridContainer');
    if (!container || !('MutationObserver' in window)) return;

    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(() => applyView(getSavedView() || getDefaultView(), false));
    });

    observer.observe(container, { childList: true, subtree: false });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initSwitcher();
    observeProductGridRefresh();
  });
})();
